module.exports = __webpack_public_path__ + "static/media/peterArt7.e960c0f4.jpg";